module.exports = __webpack_public_path__ + "3a56d8f5ecafb6dcb422c8c2e4519bce.pdf";